/**
 * Unsaved-changes leave guard (CRM wide, one active form at a time).
 *
 * A form with unsaved state registers { isDirty, prompt } while it is open:
 *   isDirty()            -> boolean
 *   prompt(proceed, stay) -> opens OUR confirm modal (never window.confirm);
 *                           calls proceed() to leave, stay() to abort.
 * The router's beforeEach calls `check(next)`; the form's own "Close" button
 * calls `confirmLeave(fn)`. `window.beforeunload` (reload / tab close) is the
 * one place where only the browser's native prompt exists — handled here too.
 */
let active = null;

const onBeforeUnload = (e) => {
  if (active && active.isDirty()) {
    e.preventDefault();
    e.returnValue = ''; // required by Chrome to show its native prompt
  }
};

export default {
  register(guard) {
    active = guard;
    window.addEventListener('beforeunload', onBeforeUnload);
  },
  unregister(guard) {
    if (!guard || active === guard) {
      active = null;
      window.removeEventListener('beforeunload', onBeforeUnload);
    }
  },
  isDirty() {
    return !!(active && active.isDirty());
  },
  // Router usage: continue navigation unless dirty; then ask via the form's modal.
  check(next) {
    if (!active || !active.isDirty()) return next();
    active.prompt(() => next(), () => next(false));
  },
  // In-app usage (close button etc.): run `leave` directly or after confirmation.
  confirmLeave(leave) {
    if (!active || !active.isDirty()) return leave();
    active.prompt(leave, () => {});
  },
};
